import { render, staticRenderFns } from "./LocationEdit.vue?vue&type=template&id=1f89b8b0"
import script from "./LocationEdit.vue?vue&type=script&lang=js"
export * from "./LocationEdit.vue?vue&type=script&lang=js"
import style0 from "./LocationEdit.vue?vue&type=style&index=0&id=1f89b8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports